export default "__VITE_ASSET__CWyiYLPV__"